import React from 'react';

import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Tooltip from "@mui/material/Tooltip";

import noImage from './../images/icons/noImage_1.png';

class Allergen extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      allergen: {
        iref: "",
        name: "",
        image: noImage,
        image_on: noImage,
        image_off: noImage,
      },
      edit: false,
      imageStatus: false,
      //doReset: false
    };
    
  }

  componentDidMount ( ) {
    if ( this.props ) {
      this.setState ( { allergen: this.props } );
      if ( this.props.edit !== undefined )
        this.setState ( { edit: this.props.edit} );
      if ( this.props.edit !== undefined )
        this.setState ( { edit: this.props.edit } );

      if ( this.props.isOn )
        this.setState ( { imageStatus: true } );
    }
  }

  componentDidUpdate ( prevProps ) {    
    if ( prevProps.doReset !== this.props.doReset && this.props.doReset === true ){
      //this.setState({doReset: this.props.doReset })
      this.setState ( { imageStatus: false } );
    }
    if ( prevProps !== this.props ) {
      if ( this.props ) {
        this.setState ( { allergen: this.props } );
        if ( this.props.edit !== undefined )
          this.setState ( { edit: this.props.edit} );

        if ( this.props.isOn )
          this.setState ( { imageStatus: true } );
      }
    }
  }

  sendToggleFilter ( name, type ) {
    let imageStatus = this.state.imageStatus;
    this.props.onClickFunction ( name, type );
    this.setState ( { imageStatus: !imageStatus } );
  }

  render() {
    let iref = null;
    let name = "";
    let image = null;
    let image_on = "";
    let image_off = "";
    let onClickFunction = null;
    let doReset = false;

    if ( this.state.allergen ) {
      let allergen = this.state.allergen;
      if ( allergen.iref ) iref = allergen.iref;
      if ( allergen.name ) name = allergen.name;
      if ( allergen.image ) image = allergen.image;
      if ( allergen.image_on ) image_on = allergen.image_on;
      if ( allergen.image_off ) image_off = allergen.image_off;
      //if ( allergen.onClickFunction ) onClickFunction = allergen.onClickFunction;
      //if ( this.props.udpated ) udpated = this.props.udpated;
    }
    //this.setState ( {updated: updated} );

    //console.log ( this.state.updated );

    return (
    
          <Tooltip title={name} arrow disableInteractive>
            <span>
              <IconButton
                key={iref}
                aria-label={name}
                onClick={() => this.sendToggleFilter("allergens", iref)}
                disabled={!this.state.edit}
              >
                <Avatar
                  key={iref}
                  alt={name}
                  src={image ? image : this.state.imageStatus ? image_on : image_off}
                  sx={{ width: 32, height: 32 }}
                />
              </IconButton>
            </span>
          </Tooltip>
   
    );

  }
}

export default Allergen;